import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken, getToken } from "@/lib/api";
import { applyBrand } from "@/lib/theme";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [company, setCompany] = useState(null);
  const [status, setStatus] = useState("loading"); // loading | authed | anon

  const applyAuth = useCallback((data) => {
    setToken(data.token);
    setUser(data.user);
    setCompany(data.company);
    setStatus("authed");
  }, []);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setCompany(data.company);
    } catch (e) {
      if (process.env.NODE_ENV !== "production") console.debug("auth refresh failed", e);
    }
  }, []);

  useEffect(() => {
    (async () => {
      if (!getToken()) {
        setStatus("anon");
        return;
      }
      try {
        const { data } = await api.get("/auth/me");
        setUser(data.user);
        setCompany(data.company);
        setStatus("authed");
      } catch {
        setToken(null);
        setStatus("anon");
      }
    })();
  }, []);

  const logout = useCallback(() => {
    setToken(null);
    setUser(null);
    setCompany(null);
    setStatus("anon");
    applyBrand(null);
  }, []);

  useEffect(() => {
    applyBrand(company?.brand_color || null);
  }, [company?.brand_color]);

  return (
    <AuthContext.Provider value={{ user, company, status, applyAuth, refresh, logout, setCompany }}>
      {children}
    </AuthContext.Provider>
  );
}
